<template>
    <div class="mdc-dialog">
        <div class="mdc-dialog__container">
            <div class="mdc-dialog__surface"
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="my-dialog-title"
                aria-describedby="my-dialog-content">
                <div class="mdc-dialog__content" id="my-dialog-content">
                    <div class="message-success">
                        <h6>{{message}}</h6>
                    </div>
                </div>

            </div>
        </div>
        <div class="mdc-dialog__scrim"></div>
    </div>
</template>
<script>
import {MDCRipple} from '@material/ripple';

export default {
props:['message'],
mounted() {
},
}
</script>
<style lang="scss" scoped>
.message-success{
    text-align: center;
    padding: 1rem;
}
</style>
